import React from 'react';
import streamingConfig from '../../config/streaming-config.js';
import { resolveMemberStreamKey, buildStreamKey } from '../../utils/dashboard';

/**
 * 直播弹窗：密码解锁 + 推流地址列表
 */
export default function LiveStreamUrlPanel({
  member,
  urlsUnlocked,
  showPwdForm,
  pwdInput,
  pwdError,
  loadingPwd,
  onToggleUrls,
  onPwdChange,
  onUnlock,
  onCancelPwd
}) {
  return (
    <div style={{
      background: '#f7f8fa',
      padding: '6px 10px',
      borderRadius: 6,
      border: '1px solid #e8eaed'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
        fontSize: 12,
        color: '#555',
        lineHeight: 1.4
      }}>
        <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 5,
          color: '#2e7d32',
          fontWeight: 600
        }}>
          <span style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: '#4caf50',
            display: 'inline-block'
          }} />
          直播中
        </span>
        <span style={{ color: '#ddd' }}>|</span>
        <span>{member.name}</span>
        <span style={{ color: '#ddd' }}>|</span>
        <span style={{ color: '#888' }}>{new Date().toLocaleString()}</span>
        <span style={{ flex: 1 }} />
        <button
          type="button"
          onClick={onToggleUrls}
          style={{
            background: urlsUnlocked ? '#eee' : '#1976d2',
            color: urlsUnlocked ? '#555' : '#fff',
            border: 'none',
            borderRadius: 4,
            padding: '2px 8px',
            fontSize: 11,
            cursor: 'pointer',
            fontWeight: 500,
            height: 22,
            lineHeight: '18px'
          }}
        >
          {urlsUnlocked ? '收起地址' : '地址（需密码）'}
        </button>
      </div>

      {showPwdForm && !urlsUnlocked && (
        <div style={{
          marginTop: 8,
          padding: 8,
          background: '#fff',
          border: '1px solid #dde3ea',
          borderRadius: 6,
          maxWidth: 340
        }}>
          <div style={{ fontSize: 11, color: '#666', marginBottom: 6 }}>
            输入指挥系统访问密码查看地址
          </div>
          <input
            type="password"
            value={pwdInput}
            onChange={(e) => onPwdChange?.(e.target.value)}
            placeholder="访问密码"
            onKeyDown={(e) => { if (e.key === 'Enter') onUnlock?.(); }}
            style={{
              width: '100%',
              height: 28,
              fontSize: 12,
              borderRadius: 4,
              border: '1px solid #bbb',
              padding: '0 8px',
              boxSizing: 'border-box',
              marginBottom: 6
            }}
          />
          <div style={{ display: 'flex', gap: 6 }}>
            <button
              type="button"
              onClick={onUnlock}
              disabled={loadingPwd}
              style={{
                flex: 1,
                height: 28,
                background: '#1976d2',
                color: '#fff',
                border: 'none',
                borderRadius: 4,
                fontSize: 12,
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              {loadingPwd ? '验证中…' : '验证'}
            </button>
            <button
              type="button"
              onClick={onCancelPwd}
              style={{
                height: 28,
                padding: '0 10px',
                background: '#f0f0f0',
                color: '#555',
                border: '1px solid #ddd',
                borderRadius: 4,
                fontSize: 12,
                cursor: 'pointer'
              }}
            >
              取消
            </button>
          </div>
          {pwdError ? (
            <div style={{ color: '#d32f2f', fontSize: 11, marginTop: 6 }}>{pwdError}</div>
          ) : null}
        </div>
      )}

      {urlsUnlocked && (() => {
        const streamKey = resolveMemberStreamKey(member) || buildStreamKey(member.name);
        const webrtc = streamingConfig.getWebRtcUrl(streamKey) || '';
        const host = webrtc.replace(/^webrtc:\/\//, '').split('/')[0] || 'zh.lqsos.cn';
        const srtHost = host.split(':')[0];
        return (
          <div style={{
            marginTop: 8,
            fontSize: 11,
            color: '#444',
            lineHeight: 1.55,
            background: '#fff',
            border: '1px solid #e6e6e6',
            borderRadius: 6,
            padding: '8px 10px'
          }}>
            <div style={{ color: '#999', fontSize: 10, marginBottom: 4 }}>关闭弹窗后自动锁定</div>
            <div><strong>SRT 网址：</strong>srt://{srtHost}:10080</div>
            <div><strong>SRT Streamid：</strong>#!::r=live/{streamKey},m=publish</div>
            <div><strong>RTMP：</strong>{streamingConfig.getRtmpUrl(streamKey)}</div>
            <div><strong>WebRTC：</strong>{streamingConfig.getWebRtcUrl(streamKey)}</div>
            <div><strong>FLV：</strong>{streamingConfig.getFlvUrl(streamKey)}</div>
          </div>
        );
      })()}
    </div>
  );
}
